<div id="main-container" class="col-md-4 bannerBg">
  <h1 class="adovacyTitle">{{ mainTitle }}</h1>
</div>

<div id="questionLists" class="col-md-10 mt-5">
  <table style="table-layout: fixed;" border="0" cellspacing="0">
    <tr>
      <td width="550px" style="background-color: transparent; color: black;">
        <label for="radioButton">
          <input
            id="radioButton"
            type="radio"
            name="t"
            value="bill"
            checked="checked"
          />
          Bill Number
        </label>
        <label for="keywordInput">
          <input
            id="keywordInput"
            style="color: #002a60;"
            type="radio"
            name="t"
            value="keyword"
          />
          Keyword

          <input
            style="color: #002a60;"
            type="text"
            name="s"
            size="40"
            aria-labelledby="user-input"
          />
        </label>
        <select style="color: black;" name="session">
          <option selected="selected" value="21">2021-2022</option>
          <option value="19">2019-2020</option>
          <option value="17">2017-2018</option>
          <option value="15">2015-2016</option>
          <option value="13">2013-2014</option>
          <option value="11">2011-2012</option>
          <option value="09">2009-2010</option>
          <option value="07">2007-2008</option>
          <option value="05">2005-2006</option>
          <option value="03">2003-2004</option>
          <option value="01">2001-2002</option>
        </select>
      </td>
      <td width="50px" style="text-align: left; background-color: transparent;">
        <a
          style="color: #002a60; text-decoration: underline;"
          onclick="runCTsearch()"
        >
          Search
        </a>
      </td>
    </tr>
  </table>
  <br />
  Report Subject:
  <select
    style="font-size: 16px;"
    class="ctselect"
    id="selectOpt"
    onchange="CTselect()"
  >
    <option
      value="https://ctweb.capitoltrack.com/public/publish.aspx?id=17dce531-a079-4846-8b7d-0803cf3e50c8"
    >
      All Tracked
    </option>
    <option
      value="https://ctweb.capitoltrack.com/public/publish.aspx?id=d4f62ed2-b867-416e-b0e0-4350b961560f"
    >
      Support
    </option>
  </select>
  <div style="text-align: right;">
    <!-- <button onclick="window.print()">Print this page</button> -->
    <a
      style="color: #282860; text-decoration: underline;"
      onclick="CTprintview()"
    >
      Print View
    </a>
  </div>
  <p>
    <!-- the src of the iframe begins with the default report to display , this should match the first report listed in above select statement -->
    <!-- 
      NOTE ON UPGRADE TO ANGULAR 15:
      Existing <iframe> instances might have security-sensitive attributes applied to them as an attribute or property binding. These security-sensitive attributes can occur in a template or in a directive's host bindings. Such occurrences require an update to ensure compliance with the new and stricter rules about <iframe> bindings. For more information, see the error page.
     -->
    <iframe
      aria-label="Data"
      align="top"
      frameborder="0"
      height="800"
      id="ct-iframe"
      src="https://ctweb.capitoltrack.com/public/publish.aspx?id=17dce531-a079-4846-8b7d-0803cf3e50c8"
      width="100%"
    ></iframe>
  </p>
</div>
